<template lang="html">
  <div class="loading">
    <v-progress-linear
      :active="getLoadingAxiosState"
      indeterminate
      absolute
      top
      rounded
    ></v-progress-linear>
    <div v-if="getLoadingAxiosState" class="__loading">
      <v-overlay :value="overlay" color="white">
        <v-progress-circular :size="50" color="primary" indeterminate />
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      overlay: true,
    };
  },
  computed: {
    ...mapGetters(["getLoadingAxiosState"]),
  },
};
</script>
<style lang="scss">
.__loading {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999;
}
</style>
